export const DEFAULT_ORG_TIME_ZONE = 'America/Argentina/Buenos_Aires';

export const ORG_TIME_ZONES: { id: string; label: string }[] = [
  { id: 'America/Montevideo', label: 'Montevideo (Uruguay)' },
  { id: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires (Argentina)' },
  { id: 'America/Argentina/Cordoba', label: 'Córdoba (Argentina)' },
  { id: 'America/Sao_Paulo', label: 'San Pablo (Brasil)' },
  { id: 'America/Santiago', label: 'Santiago (Chile)' },
  { id: 'America/Asuncion', label: 'Asunción (Paraguay)' },
  { id: 'America/La_Paz', label: 'La Paz (Bolivia)' },
  { id: 'America/Lima', label: 'Lima (Perú)' },
  { id: 'America/Bogota', label: 'Bogotá (Colombia)' },
  { id: 'America/Mexico_City', label: 'Ciudad de México' },
  { id: 'America/New_York', label: 'Nueva York (Estados Unidos)' },
  { id: 'Europe/Madrid', label: 'Madrid (España)' },
  { id: 'UTC', label: 'UTC' },
];
